import { render } from "./MainHeader.vue?vue&type=template&id=749cc26a&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=749cc26a&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749cc26a"]])

export default __exports__